import _ from 'underscore';
import templateStr from 'text!./request-policy.html';
import 'portalConfig';
import moment from 'moment';
import DateUtil from 'gw-portals-util-js/DateUtil';
import LocalDateUtil from 'gw-portals-util-js/LocalDateUtil';

export default (function () {
    return {
        restrict: 'A',
        template: templateStr,
        transclude: true,
        scope: {
            policy: '=',
            hideForm: '&'
        },
        controller: ['$scope', 'PolicyService', '$q', 'ModalService', 'ViewModelService', '$state', '$filter', '$stateParams', function ($scope, PolicyService, $q, ModalService, ViewModelService, $state, $filter, $stateParams) {
            //Controller to create request for the selected items
            $scope.dataLoaded = false;
            $scope.ETSelected = false;
            $scope.countriesLoaded = false;
            $scope.validationMsg = false;
            $scope.descValidation = false;
            $scope.ETValidationMsg = false;
            $scope.errRequestoptionExceed = false;
            $scope.selectedList = {};
            $scope.selectedData = [];
            $scope.BCValidationMsg = false;

            PolicyService.getRequestData().then(function (res) {
                $scope.requestDataList = res;
                $scope.dataLoaded = true;
            });
            /**
            * Function that returns list of ETCountries specified in etcountries.properties file in PolicyCenter.
            * @params{void}
            * @returns{Array} - list housed in ETCountriesList variable and countriesLoaded value set to true
            * @private
            **/
            PolicyService.getRequestDataForETStates().then(function (res) {
                $scope.ETCountriesList = res;
                $scope.countriesLoaded = true;
            });
            $scope.policyNumber = $stateParams.policyNumber;
            $scope.request = {
                policyNumber: $scope.policyNumber
            };
            /**
               * Function that sets variable flags based on the Request type selected by the User.
               * @params{String}
               * @returns{void}
               * @private
               **/
            $scope.selectedRequest = function (res) {
                $scope.selectedList = res;
                if (res == '') {
                    $scope.validationMsg = true;
                    return;
                } else {
                    $scope.validationMsg = false;
                    if (res == "Extra Territorial Petition") {
                        $scope.ETValidationMsg = false;
                        $scope.validationMsg = false;
                        $scope.ETSelected = true;
                    } else $scope.ETSelected = false;
                    if (res == "Backdated Cancellation") {
                        $scope.BCValidationMsg = false;
                        $scope.validationMsg = false;
                        $scope.BackdatedSelected = true;
                        var currentDate = PolicyService.getCurrentDate();
                        currentDate.then(function (res) {
                            $scope.currentDate = moment(res).format("MM/DD/YYYY");
                            $scope.currentDate = new Date($scope.currentDate);
                            $scope.requestView.mSFSelectedData.value = $scope.currentDate;
                        });
                    } else {
                        $scope.BackdatedSelected = false;
                        $scope.inValidDate = false;
                        $scope.requestView.mSFSelectedData.value = "";
                    }
                }
            };

            /**
              * Function that monitors msfDescription value and  restricts Description to 5000 characters_MSF
              * @params{String, String} - newVal, oldVal
              * @returns{String|boolean} - if length is more than 1333 then resets value to old value, other sets descValidation to false and takes in the newValue
              * @private
              **/
            $scope.$watch('requestView.mSFDescription.value', function (newVal, oldVal) {
                if (newVal != undefined) {
                    if (newVal.length > 1333) {
                        $scope.descValidation = true;
                        $scope.requestView.mSFDescription.value = oldVal;
                    } else if (newVal.length < 1333) {
                        $scope.descValidation = false;
                    }
                }
            }); //End Watch

            angular.element('#requestForm').click(function () {
                $scope.requestSubmitted = false;
                $scope.$apply();
            });
            $scope.requestView = ViewModelService.create($scope.request, 'pc', 'edge.capabilities.gateway.job.cancellation.dto.RequestDTO');
            $scope.effectiveDates = moment($scope.policy.latestPeriod.effectiveDate).format("MM/DD/YYYY");
            $scope.effectiveDates = new Date($scope.effectiveDates);
            /*
            * Function to determine if Country Option should be shown if chosen response is Extra Territorial Petition
            * @param{String}
            * @returns{boolean}
            * */
            $scope.showCountryOption = function (res) {
                if (res == "Extra Territorial Petition") {
                    return true;
                } else {
                    return false;
                }
            };

            /**
            * Function to check if the backdated date that has been entered is a valid date
            * @params{Object} - date
            * @returns{boolean} - sets $scope.invalid date to true or false
            * @private
            **/
            $scope.selectDateValue = function (backDated) {
                backDated = moment(backDated).format("MM/DD/YYYY");
                backDated = new Date(backDated);
                $scope.effectiveDates = moment($scope.policy.latestPeriod.effectiveDate).format("MM/DD/YYYY");
                $scope.effectiveDates = new Date($scope.effectiveDates);
                var currentDate = PolicyService.getCurrentDate();
                currentDate.then(function (res) {
                    $scope.currentDate = moment(res).format("MM/DD/YYYY");
                    $scope.currentDate = new Date($scope.currentDate);
                    if ((backDated.valueOf() == $scope.effectiveDates.valueOf() || backDated > $scope.effectiveDates) && (backDated.valueOf() == $scope.currentDate.valueOf() || backDated < $scope.currentDate)) {
                        $scope.inValidDate = false;
                    } else {
                        $scope.inValidDate = true;
                    }
                });
            };

            /**
             * Function to show the date picker if Backdated Cancellation request is selected
             * @params{Object} - date
             * @returns{boolean}
             * @private
             **/
            $scope.showDatepicker = function (res) {
                if (res == "Backdated Cancellation") {
                    angular.element("#EffectiveDate :input").attr('readonly', 'readonly');
                    angular.element("#EffectiveDate :input").css('background-color', '#fff');
                    return true;
                } else {
                    return false;
                }
            };
            /**
              * Function that sets ETValidationMsg to true if country is empty or not selected
              * @params{void} -
              * @returns{void} - sets ETValiationMsg variable to true or false.
              * @private
              **/
            $scope.changeCountry = function () {
                var selectedCountry = angular.element('#requestCountry').val();
                if (selectedCountry == undefined || selectedCountry == "") {
                    $scope.ETValidationMsg = true;
                } else {
                    $scope.ETValidationMsg = false;
                }
            };

            $scope.blurCc = function () {
                $scope.errRequestoptionExceed = false;
            };

            /**
            * Function to setup Call to backend service to create the activity for the selected request_MSF
            * @param{Object} - selected Form elements
            * @returns{boolean|sets up Flags for Scope variables} - returns false if form is invalid or submits contents successfully
            * */
            $scope.startRequest = function (form) {
                // comment below line to fix ET petition validation issue
                $scope.BCValidationMsg = false;
                $scope.errRequestoptionExceed = false;
                var selectedCountry = angular.element('#requestCountry').val();
                if (form.EffectiveDate) var selectedDate = form.EffectiveDate.$modelValue;
                if (selectedCountry == undefined || selectedCountry == "") {
                    selectedCountry = "";
                } else {
                    selectedCountry = selectedCountry.substring(7);
                }
                if (selectedDate == undefined || selectedDate == "") {
                    selectedDate = "";
                } else {
                    selectedDate = selectedDate;
                }
                form.submitted = true;
                $scope.requestSubmitted = false;
                $scope.validationMsg = false;
                $scope.selectedData = [];

                if ($scope.selectedList) {
                    if ($scope.selectedList == "Extra Territorial Petition") {
                        if (selectedCountry == undefined || selectedCountry == "") {
                            $scope.ETValidationMsg = true;
                        } else {
                            $scope.selectedList = $scope.selectedList + " for " + selectedCountry;
                        }
                    }
                    if ($scope.selectedList == "Backdated Cancellation") {
                        if (selectedDate == undefined || selectedDate == "") {
                            $scope.BCValidationMsg = true;
                        }
                        $scope.selectedList = $scope.selectedList + " - from " + selectedDate;
                    }
                    $scope.selectedData.push($scope.selectedList);
                }

                if ($scope.selectedData) {
                    angular.forEach($scope.selectedData, function (data) {

                        if (data.length == 0 || data.length == -1 || data.length == undefined) {
                            $scope.validationMsg = true;
                            return;
                        } else {
                            $scope.validationMsg = false;
                        }
                    });
                }

                if (!form.valid || $scope.ETValidationMsg || $scope.BCValidationMsg || $scope.inValidDate) return;

                $scope.request.mSFSelectedData = $scope.selectedData;

                $scope.request.policyNumber = $scope.policyNumber;
                $scope.disableSubmit = true;
                setTimeout(function () {

                    $scope.requestPromise = PolicyService.createSubmitRequest($scope.request);

                    $scope.requestPromise.then(function (res) {
                        $scope.disableSubmit = false;
                        $scope.$emit("requestSubmitted");
                        $scope.errRequestoptionExceed = false;
                        $scope.inValidDate = false;
                        if (res.mSFDescription != undefined) $scope.requestSubmitted = true;
                    });
                }, 2000);
            };
            /**
             * Function to check if the backdated date that has been entered is a valid date
             * @params{Object} - date
             * @returns{boolean} - sets $scope.invalid date to true or false
             * @private
             **/
            $scope.validBackDate = function () {
                if ($scope.request.mSFSelectedData != '' && $scope.request.mSFSelectedData != undefined) {
                    $scope.backDated = moment($scope.request.mSFSelectedData).format("MM/DD/YYYY");
                    $scope.backDated = new Date($scope.backDated);
                    $scope.effectiveDates = moment($scope.policy.latestPeriod.effectiveDate).format("MM/DD/YYYY");
                    $scope.effectiveDates = new Date($scope.effectiveDates);
                    var currentDate = PolicyService.getCurrentDate();
                    currentDate.then(function (res) {
                        $scope.currentDate = moment(res).format("MM/DD/YYYY");
                        $scope.currentDate = new Date($scope.currentDate);
                        if (($scope.backDated.valueOf() == $scope.effectiveDates.valueOf() || $scope.backDated > $scope.effectiveDates) && ($scope.backDated.valueOf() == $scope.currentDate.valueOf() || $scope.backDated < $scope.currentDate)) {
                            $scope.inValidDate = false;
                        } else {
                            $scope.inValidDate = true;
                        }
                    });
                }
            };

            /**
             * Function to monitor msfSelectedData
             * @params{Object} - date
             * @returns{void}
             * @private
             **/
            $scope.$watch('request.mSFSelectedData', $scope.validBackDate);
        }] //End Controller
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/RequestPolicyDirective/RequestPolicy.js
// module id = 1767
// module chunks = 0